export const userInfo = {
  position: 'Position',
  hireDate: 'Hire date',
  timeOfService: 'Time of service',
  timeType: 'Time type',
};
